import './extensions';
import Vue from 'vue';
import './plugins/fontawesome';
import './plugins/sweetalert2';
import './plugins/vue-signature-pad';
import './plugins/v-calendar';
import './plugins/browserDetect';
import './plugins/portalvue';
import clickOutside from './directives/click-outside';

import App from './App.vue';
import router from './router';
import store from './store';
import './assets/tailwind.css';
import i18n from './i18n';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import VueCurrencyInput from 'vue-currency-input';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

import './appcontainer';

Vue.use(CoolLightBox);
Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.directive('click-outside', clickOutside);

Vue.config.productionTip = false;

const pluginOptions = {
	globalOptions: { currency: 'EUR', locale: 'de' },
};
Vue.use(VueCurrencyInput, pluginOptions);

const requireComponent = require.context(
	// The relative path of the components folder
	'./components',
	// Whether or not to look in subfolders
	true,
	// The regular expression used to match base component filenames
	/Base[A-Z]\w+\.(vue|js)$/,
);

requireComponent.keys().forEach(fileName => {
	// Get component config
	const componentConfig = requireComponent(fileName);

	const componentName = (fileName.split('/').pop() as string).toPascalCase().replace(/\.\w+$/, '');

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig,
	);
});

new Vue({
	router,
	store,
	i18n,
	// @ts-ignore
	render: h => h(App),
}).$mount('#app');
